import React from "react";

import { Button } from "@mapmycustomers/ui";

import styles from "./CardCta.module.scss";

interface Props {
  buttonLabel: string;
  buttonVisible?: boolean;
  children?: React.ReactNode;
  href?: string;
  onClick?: () => void;
  text?: React.ReactNode;
}

const CardCta: React.FC<Props> = ({
  buttonLabel,
  buttonVisible = true,
  children,
  href,
  onClick,
  text,
}) => (
  <section className={styles.container}>
    <div className={styles.textTitle}>{text}</div>
    {buttonVisible && (
      <Button href={href} onClick={onClick} type="primary">
        {buttonLabel}
      </Button>
    )}
    {children && <div className={styles.content}>{children}</div>}
  </section>
);

export default CardCta;
